import React from 'react';
import styled from 'styled-components';
import { Space } from 'antd';
import moment from 'moment/moment';

import Icon from 'components/Icon';
import { I18n } from 'react-redux-i18n';

const NotebookContentContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;
  column-gap: 16px;

  .notebook-calendar-container {
    display: flex;
    min-width: 60px;
  }

  .icon-calendar {
    width: 60px;
    height: 60px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f9dfd6;
    color: ${(props) => props.theme.colors['dark']};
  }

  .notebook-city {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 16px;
    font-family: ${(props) => props.theme.fonts.oswald};
    color: #2b3d54;
  }

  .notebook-date {
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-family: ${(props) => props.theme.fonts.oswald};
    white-space: nowrap;
    font-size: 14px;
  }

  .notebook-network {
    display: inline;
    margin-left: 8px;
    padding: 4px 8px;
    border-radius: 40%;
    background-color: rgba(31, 43, 55, 0.04);
    color: ${(props) => props.theme.colors['dark']};
  }
`;

const NotebookContent = ({
  name,
  network,
  date,
  formatDate = 'DD.MM.YYYY',
  showCalendarIcon = false,
  continiousMode = false
}) => {
  const calendarIconContent = showCalendarIcon && (
    <div className="notebook-calendar-container">
      <div className="icon-calendar">
        <Icon icon="calendar" />
      </div>
    </div>
  );

  return (
    <NotebookContentContainer>
      {calendarIconContent}
      <Space direction="vertical" size="1">
        <div className="notebook-city">
          {name.toUpperCase()}
          <div className="notebook-network">{network}</div>
          {continiousMode && (
            <Icon
              icon="rssIcon"
              alt="continuous-icon"
              style={{ marginLeft: '10px', color: '#e25d34' }}
            />
          )}
        </div>
        <div className="notebook-date">
          {continiousMode
            ? I18n.t('restaurants&caves.nowVision')
            : moment(date, 'YYYY-MM-DD').format(formatDate)}
        </div>
      </Space>
    </NotebookContentContainer>
  );
};

export default NotebookContent;
